import {
  IBieOnboardingValidationIssue,
} from './bieonboardingworkbench.models';

const asObject = (value: unknown): Record<string, unknown> =>
  value && typeof value === 'object' && !Array.isArray(value)
    ? value as Record<string, unknown>
    : {};

const asNumber = (value: unknown, fallback = 0): number => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

const asString = (value: unknown): string =>
  value === undefined || value === null ? '' : String(value);

/**
 * Normalizes the authoritative vwx_bieonboardingissue contract into the
 * established Onboarding UI issue model.
 *
 * Authoritative aliases:
 *   ruc/run/rui, blk, sht, vmg, sov, vdt, sor, vlr
 *
 * UI aliases:
 *   rlc/rln/rli, ibl, ssh, msg, src, vdd, exo
 */
export const normalizeBieOnboardingValidationIssue = (
  input: any,
): IBieOnboardingValidationIssue => {
  const validationDetails = {
    ...asObject(input?.vdt ?? input?.vdd),
  };

  if (input?.vlr !== undefined && input?.vlr !== null) {
    validationDetails.incomingValue = input.vlr;
  }

  return {
    ...input,

    rid: input?.rid,
    rix: asString(input?.rix),

    iti: input?.iti,
    itx: asString(input?.itx),

    imi: input?.imi,
    imx: asString(input?.imx),
    imc: asString(input?.imc),
    imn: asString(input?.imn),

    lsi: input?.lsi,
    lsx: asString(input?.lsx),
    lsc: asString(input?.lsc),
    lsn: asString(input?.lsn),

    cli: input?.cli,
    clx: asString(input?.clx),
    clc: input?.clc,
    cln: asString(input?.cln),

    lin: asNumber(input?.lin ?? input?.srw),

    ssh: asString(input?.ssh ?? input?.sht),
    srw: asNumber(input?.srw),
    srf: asString(input?.srf),

    rli: input?.rli ?? input?.rui,
    rlx: asString(input?.rlx ?? input?.rux),
    rlc: asString(input?.rlc ?? input?.ruc).toUpperCase(),
    rln: asString(input?.rln ?? input?.run),

    exo: asNumber(input?.exo ?? input?.sor),

    svi: input?.svi,
    svx: asString(input?.svx),
    svc: input?.svc,
    svn: asString(input?.svn),

    svl: asNumber(input?.svl),
    ibl: asNumber(input?.ibl ?? input?.blk),

    fld: asString(input?.fld),
    src: input?.src ?? input?.sov ?? input?.vlr ?? null,

    msg: asString(input?.msg ?? input?.vmg),
    vdd: validationDetails,

    ict: asString(
      input?.ict ??
      (asNumber(input?.ibl ?? input?.blk) === 1 ? 'BLOCKING' : 'REVIEW'),
    ),

    dcd: asString(input?.dcd),
    exi: asObject(input?.exi),

    sts: asNumber(input?.sts, 1),
    ast: asNumber(input?.ast ?? input?.sts, 1),
    stp: asString(input?.stp),
  } as IBieOnboardingValidationIssue;
};
